// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1nZs2","emails":"CreateEditClinics_emails__2WNR9","emailTagLabel":"CreateEditClinics_emailTagLabel__2Gye2"};